/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Full_Stack_Web_Apps_Sell_Title4Inputs */

const en_svc_full_stack_web_apps_sell_title4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Sell_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monetize it`)
};

const ar_svc_full_stack_web_apps_sell_title4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Sell_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحصول على ربح`)
};

const bn_svc_full_stack_web_apps_sell_title4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Sell_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মনিটাইজ করুন`)
};

const de_svc_full_stack_web_apps_sell_title4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Sell_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monetarisieren Sie es`)
};

const es_svc_full_stack_web_apps_sell_title4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Sell_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monetizarlo`)
};

const fr_svc_full_stack_web_apps_sell_title4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Sell_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monétisez-le`)
};

const pt_svc_full_stack_web_apps_sell_title4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Sell_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monetize`)
};

const zh_svc_full_stack_web_apps_sell_title4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Sell_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`货币化`)
};

const tr_svc_full_stack_web_apps_sell_title4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Sell_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para kazanın`)
};

const ru_svc_full_stack_web_apps_sell_title4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Sell_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Монетизируйте это`)
};

const pl_svc_full_stack_web_apps_sell_title4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Sell_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarabiaj`)
};

/**
* | output |
* | --- |
* | "Monetize it" |
*
* @param {Svc_Full_Stack_Web_Apps_Sell_Title4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_full_stack_web_apps_sell_title4 = /** @type {((inputs?: Svc_Full_Stack_Web_Apps_Sell_Title4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Full_Stack_Web_Apps_Sell_Title4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_full_stack_web_apps_sell_title4(inputs)
	if (locale === "bn") return bn_svc_full_stack_web_apps_sell_title4(inputs)
	if (locale === "de") return de_svc_full_stack_web_apps_sell_title4(inputs)
	if (locale === "es") return es_svc_full_stack_web_apps_sell_title4(inputs)
	if (locale === "fr") return fr_svc_full_stack_web_apps_sell_title4(inputs)
	if (locale === "pt") return pt_svc_full_stack_web_apps_sell_title4(inputs)
	if (locale === "zh") return zh_svc_full_stack_web_apps_sell_title4(inputs)
	if (locale === "tr") return tr_svc_full_stack_web_apps_sell_title4(inputs)
	if (locale === "ru") return ru_svc_full_stack_web_apps_sell_title4(inputs)
	if (locale === "pl") return pl_svc_full_stack_web_apps_sell_title4(inputs)
	return en_svc_full_stack_web_apps_sell_title4(inputs)
});
export { svc_full_stack_web_apps_sell_title4 as "svc_full-stack-web-apps_SELL_title" }